<template>
	<aside class="menu-bar" v-bind:class="{ collapsed: privateState.isCollapsed, pulse: isPulse }">
		<div class="icon-bar" @click="toggleMenu">
			<a href="" @click.stop.prevent="toggleMenu"><i class="fas fa-arrow-right"></i></a>
			<a href="" @click.stop.prevent="toggleMenu"><i class="fas fa-arrow-left"></i></a>
		</div>
		<div class="menu-label" @click="toggleMenu"><span>{{ lang('menu') }}</span></div>
		<div class="router-menu">
			<div class="menu-items">
				<div class="menu-item">{{ lang('stories') }}
					<div class="characters-menu-wrapper" ref="characters_wrapper">
						<router-link @click="closeMenu" href="/steal-estate/character/vanessa" to="/character/vanessa">
							<img class="character-icon"
								data-src="/themes/rise-theme/dist/images/estate/character-view/characters/Vanessa@2x.png"
								data-glow-src="/themes/rise-theme/dist/images/estate/character-view/characters/Vanessa_Glow@2x.png"
								src="/themes/rise-theme/dist/images/estate/character-view/characters/Vanessa@2x.png" />
							<div class="shadow-img invisible"
								style="background-image: url(/themes/rise-theme/dist/images/estate/character-view/characters/Vanessa_Glow@2x.png)">
							</div>
						</router-link>
						<router-link @click="closeMenu" href="/steal-estate/character/henry" to="/character/henry">
							<img class="character-icon"
								data-src="/themes/rise-theme/dist/images/estate/character-view/characters/MrHenry@2x.png"
								data-glow-src="/themes/rise-theme/dist/images/estate/character-view/characters/MrHenry_Glow@2x.png"
								src="/themes/rise-theme/dist/images/estate/character-view/characters/MrHenry@2x.png" />
							<div class="shadow-img invisible"
								style="background-image: url(/themes/rise-theme/dist/images/estate/character-view/characters/MrHenry_Glow@2x.png)">
							</div>
						</router-link>
						<router-link @click="closeMenu" href="/steal-estate/character/holly" to="/character/holly">
							<img class="character-icon"
								data-src="/themes/rise-theme/dist/images/estate/character-view/characters/Holly@2x.png"
								data-glow-src="/themes/rise-theme/dist/images/estate/character-view/characters/Holly_Glow@2x.png"
								src="/themes/rise-theme/dist/images/estate/character-view/characters/Holly@2x.png" />
							<div class="shadow-img invisible"
								style="background-image: url(/themes/rise-theme/dist/images/estate/character-view/characters/Holly_Glow@2x.png)">
							</div>
						</router-link>
						<router-link @click="closeMenu" href="/steal-estate/character/ozzie" to="/character/ozzie">
							<img class="character-icon" style="margin-top: 6px;"
								data-src="/themes/rise-theme/dist/images/estate/character-view/characters/Ozzie@2x.png"
								data-glow-src="/themes/rise-theme/dist/images/estate/character-view/characters/Ozzie_Glow@2x.png"
								src="/themes/rise-theme/dist/images/estate/character-view/characters/Ozzie@2x.png" />
							<div class="shadow-img invisible"
								style="background-image: url(/themes/rise-theme/dist/images/estate/character-view/characters/Ozzie_Glow@2x.png)">
							</div>
						</router-link>
						<router-link @click="closeMenu" href="/steal-estate/character/villian" to="/character/villian">
							<img class="character-icon villian"
								data-src="/themes/rise-theme/dist/images/estate/character-view/characters/Villain@2x.png"
								data-glow-src="/themes/rise-theme/dist/images/estate/character-view/characters/Villain_Glow_1@2x.png"
								src="/themes/rise-theme/dist/images/estate/character-view/characters/Villain@2x.png" />
							<div class="shadow-img invisible"
								style="background-image: url(/themes/rise-theme/dist/images/estate/character-view/characters/Villain_Glow_1@2x.png)">
							</div>
						</router-link>
					</div>
				</div>
				<div class="menu-item">
					<router-link @click="closeMenu" href="/steal-estate" to="/">{{ lang('home') }}</router-link>
				</div>
				<div class="menu-item">
					<a href="/steal-estate/about/">{{ lang('about') }}</a>
				</div>
				<div class="menu-item">
					<a href="/steal-estate/resources/">{{ lang('resources') }}</a>
				</div>
				<div class="menu-item">
					<a href="/steal-estate/videos/">{{ lang('audio_gallery') }}</a>
				</div>
				<div class="menu-item">
					<a @click.prevent="showIntro" href="">{{ lang('tutorial') }}</a>
				</div>
				<div class="menu-item">
					<a href="https://docs.google.com/forms/d/1DwmEJBNyHAi7ySeX8WjEiLQfEkA-IYMF6DqBC_FhMxg/edit" target="_blank">{{ lang('contact') }}</a>
				</div>
				<div class="menu-item">
					<div>
						<a href="/" v-if="store.lang == 'es'" @click.prevent="setLang('en')">ENGLISH</a>
						<a href="/" v-if="store.lang == 'en'" @click.prevent="setLang('es')">ESPAÑOL</a>
					</div>
				</div>
			</div>
			<div class="menu-footer">
				<div class="line"></div>
				<div class="d-flex flex-row p-2">
					<div class="main-logo"><a href="https://risehomestories.com/" target="_blank"><img
								src="https://risehomestories.com/uploads/2022/07/RISE-HOME_KOWhite_Logo.png" /></a>
					</div>
					<div>
						<a href="/steal-estate/">STEAL ESTATE!</a> {{ lang('footer_text') }}:
					</div>
				</div>
				<div class="logos-wrap d-flex p-2 justify-content-between">
					<a href="https://risehomestories.com/alejandria/" target="_blank"><img
							src="https://risehomestories.com/uploads/2022/07/logo-alejandria-white.png"
							alt="Alejandria"></a>
					<a href="https://risehomestories.com/dots-home/" target="_blank"><img
							src="https://risehomestories.com/uploads/2022/07/DotsHomeLogo_KOWhite.png" alt="DOTS"></a>
					<a href="https://risehomestories.com/mine/" target="_blank"><img
							src="https://risehomestories.com/uploads/2022/07/MineLogo_KOWhite.png" alt="MINE"></a>
					<a href="https://risehomestories.com/but-next-time/" target="_blank"><img
							src="https://risehomestories.com/uploads/2022/07/logo-bnt-white.png" alt="But Next Time"></a>
				</div>
			</div>
		</div>
	</aside>
</template>

<script>
import GoogleTranslateSelect from "@google-translate-select/vue3";
import { store } from './store.js'

export default {
	props: ['raw_links'],
	components: {
		GoogleTranslateSelect,
	},
	data() {
		return {
			isPulse: true,
			privateState: {
				isCollapsed: true,
			},
			store
		};
	},
	inject: [
		'lang'
	],
	mounted() {
		if (this.getCookie('menu_animated')) {
			this.isPulse = false;
		} else {
			this.setCookie('menu_animated', 'true');
		}

		const ch_images = document.getElementsByClassName("character-icon");
		for (let i = 0; i < ch_images.length; i++) {
			ch_images[i].addEventListener('mouseover', e => {
				e.target.setAttribute('src', e.target.dataset.glowSrc)
			}, false);
			ch_images[i].addEventListener('mouseleave', e => {
				setTimeout(() => { e.target.setAttribute('src', e.target.dataset.src) }, 1);
			}, false);
		}
	},
	methods: {
		setLang(l) {
			store.lang = l;
			window.localStorage.setItem('user_lang', l);
		},
		setCookie(name, value, options = {}) {
			options = {
				path: '/',
				...options
			};

			if (options.expires instanceof Date) {
				options.expires = options.expires.toUTCString();
			}

			let updatedCookie = encodeURIComponent(name) + "=" + encodeURIComponent(value);

			for (let optionKey in options) {
				updatedCookie += "; " + optionKey;
				let optionValue = options[optionKey];
				if (optionValue !== true) {
					updatedCookie += "=" + optionValue;
				}
			}

			document.cookie = updatedCookie;
		},
		getCookie(name) {
			let matches = document.cookie.match(new RegExp(
				"(?:^|; )" + name.replace(/([\.$?*|{}\(\)\[\]\\\/\+^])/g, '\\$1') + "=([^;]*)"
			));
			return matches ? decodeURIComponent(matches[1]) : undefined;
		},
		closeMenu(e) {
			this.privateState.isCollapsed = true;
			if (this.raw_links == 1) {
				let href = '';

				if (e.target.parentElement &&
					e.target.parentElement.attributes.length &&
					!e.target.parentElement.classList.contains('menu-item')) {

					href = e.target.parentElement.attributes.getNamedItem('href').value;

					if (href.length) {
						window.location.href = href;
					}
				} else if (e.target.parentElement &&
					e.target.parentElement.attributes.length &&
					e.target.parentElement.classList.contains('menu-item')) {

					href = e.target.attributes.getNamedItem('href').value;

					if (href.length) {
						window.location.href = href;
					}
				}
			} else {
				this.$navigate.value = true;
				setTimeout(() => {
					this.$navigate.value = false;
				}, 1000);
				window.scrollTo({
					top: 0,
					behavior: 'smooth'
				});
			}
		},
		toggleMenu() {
			this.isPulse = false;
			this.privateState.isCollapsed = !this.privateState.isCollapsed;
		},
		showIntro() {
			this.store.showTutorial = true;
			const eventTarget = document.querySelector('#app');
			const event = new CustomEvent('trigger-tutorial', {
				bubbles: true,
			});
			eventTarget.dispatchEvent(event);
			this.privateState.isCollapsed = true;
		},
	}
}
</script>

<style lang="scss" scoped>
.pulse {
	animation: bounce2 1.2s ease-in 5;
}
@keyframes bounce2 {
	0%, 20%, 50%, 80%, 100% {transform: translateY(0);}
	40% {transform: translateY(30px);}
	60% {transform: translateY(15px);}
}

.google-translate {
	padding-left: 0 !important;
	text-transform: uppercase;
}

router-link {
	cursor: pointer;

	&:hover {
		color: #fff;
		text-decoration: underline;
	}
}

.disabled {
	pointer-events: none;

	img {
		filter: brightness(0.35);
	}
}

.menu-bar {
	max-width: 350px;
	background-color: #000;
	height: 100%;
	position: fixed;
	width: 100%;
	transition: max-width 0.3s ease-in-out;
	z-index: 21;
	box-shadow: 0 0 25px #000;
	top: 0;

	@media(min-width: 600px) and (max-width: 1280px) {
		zoom: 0.65;
	}

	@media(max-width: 400px) {
		zoom: 0.8;
	}

	@media screen and (max-width: 991px) and (orientation: landscape) {
		max-width: 600px;
	}


	&.collapsed {
		max-width: 35px;

		@media (max-width: 600px) {
			max-width: 0;
		}

		.icon-bar {
			cursor: pointer;

			.fa-arrow-left {
				display: none;
			}

			.fa-arrow-right {
				display: block;

				@media(max-width: 600px) {
					top: 50%;
					transform: translateY(-50%);
				}
			}

			@media(max-width: 600px) {
				position: absolute;
				width: 35px;
				height: 75px;
				left: 0;
				top: 8%;
				box-shadow: 0 0 15px #000;
			}
		}

		.router-menu {
			visibility: hidden;
			opacity: 0;
		}

		.characters-menu-wrapper {
			opacity: 0 !important;

			a {
				display: none !important;
			}
		}
	}

	.router-menu {
		visibility: visible;
		opacity: 1;
		transition: opacity 0.5s;
		height: calc(100% - 36px);
		display: flex;
		flex-direction: column;
		overflow-y: scroll;
		-ms-overflow-style: none;
		scrollbar-width: none;

		&::-webkit-scrollbar {
			display: none;
		}

		@media(min-width: 600px) {
			height: calc(100% - 116px);
		}
	}


	.icon-bar {
		height: 35px;
		background-color: #b33533;

		a {
			cursor: pointer;
		}

		.fa-arrow-right {
			display: none;
		}

		svg {
			color: #fff;
			position: absolute;
			top: 10px;
			right: 10px;

			@media screen and (max-width: 991px) and (orientation: landscape) {
				top: 6px;
				right: 6px;
			}

		}
	}

	.menu-items {
		flex-grow: 1;
	}

	.menu-footer {
		color: #fff;
		font-size: 12px;
		max-width: 350px;

		a {
			color: #91b621;
		}

		.main-logo {
			margin-right: 15px;

			img {
				max-width: 70px;

				@media(max-width: 400px) {
					max-width: 60px;
				}
			}
		}

		.line {
			height: 7px;
			width: 100%;
			background-image: url('/themes/rise-theme/dist/images/estate/character-view/line.jpeg');
			background-repeat: no-repeat;
			background-size: cover;
			margin-bottom: 10px;
			position: relative;
			left: 0;
		}

		.logos-wrap {
			max-width: 350px;
			height: 55px;

			@media(max-width: 400px) {
				height: 40px;
			}

			a {
				display: block;

				img {
					max-height: 40px;

					@media(max-width: 400px) {
						max-height: 30px;
					}
				}
			}
		}
	}

	.menu-label {
		position: relative;
		height: 80px;
		border-bottom: 1px solid #999;
		user-select: none;
		cursor: pointer;

		span {
			position: absolute;
			right: -14px;
			color: #fff;
			text-transform: uppercase;
			transform: rotateZ(-90deg);
			top: 24px;
			font-family: 'Calder-DarkGrit', Verdana, Geneva, Tahoma, sans-serif;
			font-size: 18px;

			@media screen and (max-width: 991px) and (orientation: landscape) {
				font-size: 13px;
				right: -17px;
			}

		}

		@media(max-width: 600px) {
			display: none;
		}
	}

	.menu-item {
		font-family: 'Calder-DarkGrit', Verdana, Geneva, Tahoma, sans-serif;
		font-size: 18px;
		color: #aaa;
		border-bottom: 1px solid #aaa;
		padding: 10px 0 10px 10px;

		@media(max-width: 400px) {
			font-size: 14px;
			padding: 7px 0 7px 10px;
		}

		&.active {
			color: #fff;
		}

		a {
			color: #aaa;

			&:hover {
				color: #fff;
			}
		}

		.characters-menu-wrapper {
			display: flex;
			flex-wrap: wrap;
			padding: 10px 0;
			opacity: 1;
			transition: 0.5s 0.3s;

			img {
				max-width: 100px;
				margin: 6px;
				transition: 0.5s;
				transform-origin: center 10px;

				@media(max-width: 400px) {
					margin: -8px 0px;
				}

				&:hover {
					transform: scale(1.2) rotateZ(5deg);
				}

				&.villian {
					margin-top: 13px;
					transform: rotate(-5deg);

					&:hover {
						transform: scale(1.3) rotateZ(2deg);
					}
				}
			}
		}
	}
}</style>
